import { Box, IconButton, Image, MediaOverlay, Tooltip, Transition } from '@wix/design-system';
import { Minimise } from '@wix/wix-ui-icons-common';
import React, { useEffect, useState } from 'react';
import { EditorHost } from '../../../../types';
import { resolveCapabilitiesForEditorHost } from '../../../../utils/editor-capabilities-from-host';
import { wdsThemeColors } from '../../../../utils/wds-theme-colors';
import { useSharedAltTextScreenContext } from '../context/alt-text-screen-context';
const SvgEnlargedImageBackground = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    height: height,
    preserveAspectRatio: "none",
    viewBox: `0 0 ${width} ${height}`,
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: wdsThemeColors.imagePlaceholder,
    height: height,
    rx: "4",
    width: width
  }));
};
export const EnlargedImage = _ref2 => {
  var _context$wizardPresen;
  let {
    imageUrl,
    isEnlarged,
    onMinimize,
    originalSize,
    resizeImageUrl,
    minimizeTooltip: minimizeTooltipProp
  } = _ref2;
  const [urlToShow, setUrlToShow] = useState(imageUrl);
  const context = useSharedAltTextScreenContext();
  const editorHost = context.editorHost ?? EditorHost.odeditor;
  const minimizeTooltip = minimizeTooltipProp ?? context.translations.imageItem.minimizeButtonTooltip;
  const {
    width: enlargedImageWidth,
    maxHeight: enlargedImageMaxHeight
  } = ((_context$wizardPresen = context.wizardPresentation) == null ? void 0 : _context$wizardPresen.enlargedPreviewSize) ?? resolveCapabilitiesForEditorHost(editorHost).wizardPresentation.enlargedPreviewSize;
  const enlargedImageHeight = enlargedImageMaxHeight;
  const displayWidth = originalSize && originalSize.width <= 84 ? originalSize.width : enlargedImageWidth;
  const displayHeight = originalSize && originalSize.height <= 84 ? originalSize.height : enlargedImageMaxHeight;
  useEffect(() => {
    let isMounted = true;
    const resolveUrl = async () => {
      if (!resizeImageUrl) {
        setUrlToShow(imageUrl);
        return;
      }
      try {
        const resized = await resizeImageUrl(imageUrl);
        if (isMounted) {
          setUrlToShow(resized);
        }
      } catch (err) {
        console.error('Failed to resize image', err);
        setUrlToShow(imageUrl);
      }
    };
    resolveUrl();
    return () => {
      isMounted = false;
    };
  }, [imageUrl, resizeImageUrl]);
  return /*#__PURE__*/React.createElement(Transition, {
    dataHook: "enlarged-image-transition",
    enterAnimation: {
      fadeIn: {
        delay: 'short',
        duration: 'medium02',
        easing: 'enterEasing'
      },
      scaleUp: {
        delay: 'short',
        direction: 'topStart',
        duration: 'medium02',
        easing: 'enterEasing',
        scale: '100%'
      }
    },
    exitAnimation: {
      fadeOut: {
        duration: 'medium01',
        easing: 'exitEasing'
      },
      scaleDown: {
        direction: 'topStart',
        duration: 'medium01',
        easing: 'exitEasing',
        scale: '0%'
      }
    },
    show: isEnlarged
  }, /*#__PURE__*/React.createElement(Box, {
    dataHook: "enlarged-image-container",
    height: enlargedImageHeight,
    paddingTop: "5px" // TODO: consider replacing px with SP token
    ,
    position: "relative",
    width: "100%"
  }, /*#__PURE__*/React.createElement(MediaOverlay, {
    borderRadius: "4px" // TODO: consider replacing px with SP token
    ,
    hoverSkin: "none",
    media: /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SvgEnlargedImageBackground, {
      height: enlargedImageHeight,
      width: enlargedImageWidth
    }), /*#__PURE__*/React.createElement(Box, {
      align: "center",
      "align-items": "center",
      height: enlargedImageHeight,
      justifyItems: "center",
      position: "absolute",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Image, {
      borderRadius: 0,
      dataHook: "enlarged-image-image",
      fit: "contain",
      height: displayHeight,
      position: "center",
      src: urlToShow,
      transparent: true,
      width: displayWidth,
      onClick: onMinimize
    }))),
    onClick: onMinimize
  }, /*#__PURE__*/React.createElement(MediaOverlay.Content, {
    placement: "top-end",
    visible: "hover"
  }, isEnlarged && /*#__PURE__*/React.createElement(Tooltip, {
    content: minimizeTooltip,
    placement: "top",
    size: "small"
  }, /*#__PURE__*/React.createElement(Box, {
    paddingBottom: "2px",
    paddingTop: "2px"
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": minimizeTooltip,
    dataHook: "enlarged-image-minimize-button",
    priority: "secondary",
    size: "small",
    onClick: onMinimize
  }, /*#__PURE__*/React.createElement(Minimise, null))))))));
};
//# sourceMappingURL=enlarged-image.js.map